import * as Sentry from '@sentry/react';

if (process.env.REACT_APP_ENV !== 'local') {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, environment: process.env.REACT_APP_ENV });
}
